/**
 * Task E (docs/plans/2026-09-14-adaptive-question-selection-build.md, ADR-011 Section 5):
 * "one primary plus up to two alternates." `rankedSolutionIds` already carries the matcher's full
 * ranking (UC-2c); result-screen.ts (live surface) and report-template.ts (the downloadable
 * report) both cap it against `Settings.maxAlternates` (src/types.ts), so the count is a Sheet
 * edit rather than a deploy. This module holds the one piece that isn't config: the accompanying
 * copy, shared so the two surfaces can't drift apart on wording.
 *
 * Decision recorded here per the task brief's "fewer than three candidates" open question: show
 * however many genuinely rank behind the primary, up to the configured cap, and say nothing
 * further when there are none, never pad from outside the candidate set. UC-2b's candidate set is
 * the safety filter (ADR-006); reaching beyond it to fill out three cards would recommend someone
 * the deterministic stage never actually matched, which is the exact thing that filter exists to
 * prevent. A shorter, honest list is the correct behavior, not a degraded one.
 */

/**
 * DISPOSABLE placeholder, same status as fallback-copy.ts and voice-reference.ts: visitor-facing
 * LuAnn-voice text, not yet reviewed by LuAnn (UC-8), subject to the no-em-dashes rule. Nothing
 * generated using this should reach a real visitor before that review happens.
 */
export const ALTERNATES_SUBHEAD = "Based on what you told us, these could also be a fit.";
